export function formatDimensions(dimensions) {
  if (!dimensions) return null;
  if (typeof dimensions === "string") return dimensions;
  const { w, d, h, unit = "cm" } = dimensions;
  const parts = [
    w ? `W-${w} ${unit}` : null,
    d ? `D-${d} ${unit}` : null,
    h ? `H-${h} ${unit}` : null,
  ].filter(Boolean);
  return parts.join(" × ");
}
